import ZoomMtgEmbedded from "@zoom/meetingsdk/embedded";

export const loadZoomEmbeddedSdk = async () => {
  return ZoomMtgEmbedded;
};
